export const PROFILE_ACTIVITY_COLUMNS = [
  { id: "profile", label: "Fan / Visitor", alwaysVisible: true, defaultVisible: true },
  { id: "channel", label: "Channel", alwaysVisible: false, defaultVisible: true },
  { id: "source", label: "Source · campaign", alwaysVisible: false, defaultVisible: true },
  { id: "landing", label: "Landing page", alwaysVisible: false, defaultVisible: true },
  { id: "pages", label: "Pages viewed", alwaysVisible: false, defaultVisible: true },
  { id: "surface", label: "Surface", alwaysVisible: false, defaultVisible: true },
  { id: "occurred_at", label: "Occurred at", alwaysVisible: false, defaultVisible: true },
  { id: "linked_via", label: "Linked via", alwaysVisible: false, defaultVisible: false },
  { id: "visitor_id", label: "Visitor ID", alwaysVisible: false, defaultVisible: false },
];

export const getDefaultVisibleColumns = () => PROFILE_ACTIVITY_COLUMNS.filter((c) => c.defaultVisible);

export const getDefaultHiddenColumns = () => PROFILE_ACTIVITY_COLUMNS.filter((c) => !c.defaultVisible && !c.alwaysVisible);
